import { render, staticRenderFns } from "./CardItemAfterSort.vue?vue&type=template&id=0b26f594&"
import script from "./CardItemAfterSort.vue?vue&type=script&lang=js&"
export * from "./CardItemAfterSort.vue?vue&type=script&lang=js&"
import style0 from "./CardItemAfterSort.vue?vue&type=style&index=0&id=0b26f594&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports